// src/components/button/ToggleShowSensorInfo.tsx

import { InfoTwoTone } from '@mui/icons-material'
import { IconButton, Tooltip, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'

type Props = {
  onChange: (showSensorInfo: boolean) => void
}

export const ToggleShowSensorInfo = ({ onChange }: Props) => {
  const theme = useTheme()
  const { main: color } = theme.palette.secondary

  const [showSensorInfo, setShowSensorInfo] = useState(false)
  const toggle = () => setShowSensorInfo(prev => !prev)

  const icon =
    showSensorInfo === true ? <InfoTwoTone sx={{ color }} /> : <InfoTwoTone />

  const tooltip =
    showSensorInfo === true
      ? 'Informationen zum Messpunkt ausblenden'
      : 'Informationen zum Messpunkt einblenden'

  useEffect(() => onChange(showSensorInfo), [onChange, showSensorInfo])

  return (
    <Tooltip title={tooltip}>
      <IconButton onClick={toggle}>{icon}</IconButton>
    </Tooltip>
  )
}
